/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, ShearAnchorChecksOnElementDTO } from '../fastAPI.schemas'

/**
 * Shear anchor checks per stiffening segment, with each position's
Schubverbinder selection.

Locations whose stored result no longer matches their inputs are
recomputed (and stored) here.
 * @summary Get Shear Anchor Checks
 */
export const getShearAnchorChecks = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<ShearAnchorChecksOnElementDTO[]>({
    url: `/projects/${projectGuid}/shear-anchor-checks`,
    method: 'GET',
    signal,
  })
}

export const getGetShearAnchorChecksQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/shear-anchor-checks`] as const
}

export const getGetShearAnchorChecksQueryOptions = <
  TData = Awaited<ReturnType<typeof getShearAnchorChecks>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getShearAnchorChecks>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetShearAnchorChecksQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getShearAnchorChecks>>> = ({ signal }) =>
    getShearAnchorChecks(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getShearAnchorChecks>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetShearAnchorChecksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getShearAnchorChecks>>
>
export type GetShearAnchorChecksQueryError = HTTPValidationError

/**
 * @summary Get Shear Anchor Checks
 */

export function useGetShearAnchorChecks<
  TData = Awaited<ReturnType<typeof getShearAnchorChecks>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getShearAnchorChecks>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetShearAnchorChecksQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
